import { UAParser } from 'ua-parser-js';
class UserAgent extends UAParser {

};
const ua = new UserAgent;
export default ua;
